import { Label, ModalWindow, UIText1 } from '@cian/ui-kit';
import {
  IconActionChevronRight16,
  IconFileDocument16,
  IconMediaPhoto16,
  IconFileOpenFolder16,
  IconProductInstantBooking16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './AttachFileModal.css';
import { EMessageFileTypes } from '../../types/messageFiles';

type TAttachFileModalProps = {
  isOpen: boolean;
  isOfferShareAvailable: boolean;
  imageAccept: string;
  documentAccept: string;
  isDocumentUploadEnabled: boolean;
  isReplyTemplateEnabled: boolean;
  isReplyTemplateNewEnabled: boolean;
  onChange(event: React.ChangeEvent): void;
  onClick(type: EMessageFileTypes.Image | null): void;
  onClose(): void;
  onOfferSendClick(): void;
  onReplyTemplateClick(): void;
};

export const AttachFileModal: React.FC<TAttachFileModalProps> = ({
  isOpen,
  imageAccept,
  documentAccept,
  isOfferShareAvailable,
  isReplyTemplateEnabled,
  isReplyTemplateNewEnabled,
  isDocumentUploadEnabled,
  onChange,
  onClick,
  onClose,
  onOfferSendClick,
  onReplyTemplateClick,
}) => {
  return (
    <ModalWindow open={isOpen} fixed onClose={onClose} size="M">
      <input id="image-upload" value="" type="file" accept={imageAccept} multiple onChange={onChange} />
      <label
        htmlFor="image-upload"
        className={styles['section']}
        onClick={() => onClick(EMessageFileTypes.Image)}
        data-name="AttachFileModal_photo"
      >
        <div className={styles['info']}>
          <IconMediaPhoto16 />
          <UIText1>Фото</UIText1>
        </div>
        <IconActionChevronRight16 color="icon-main-default" />
      </label>
      {isDocumentUploadEnabled && (
        <>
          <input id="document-upload" value="" type="file" accept={documentAccept} multiple onChange={onChange} />
          <label
            htmlFor="document-upload"
            className={styles['section']}
            onClick={() => onClick(null)}
            data-name="AttachFileModal_document"
          >
            <div className={styles['info']}>
              <IconFileDocument16 />
              <UIText1>Документ</UIText1>
            </div>
            <IconActionChevronRight16 color="icon-main-default" />
          </label>
        </>
      )}
      {isReplyTemplateEnabled && (
        <div className={styles['section']} onClick={onReplyTemplateClick} data-name="AttachFileModal_replyTemplate">
          <div className={styles['info']}>
            <IconProductInstantBooking16 />
            <UIText1>Шаблоны ответов</UIText1>
          </div>
          <div className={styles['right-content']}>
            {isReplyTemplateNewEnabled && (
              <Label background="accent-negative-secondary" color="accent-negative-primary">
                Новое
              </Label>
            )}
            <IconActionChevronRight16 color="icon-main-default" />
          </div>
        </div>
      )}
      {isOfferShareAvailable && (
        <label
          htmlFor="offer-attach"
          className={styles['section']}
          onClick={onOfferSendClick}
          data-name="AttachFileModal_offer"
        >
          <div className={styles['info']}>
            <IconFileOpenFolder16 />
            <UIText1>Моё объявление</UIText1>
          </div>
          <IconActionChevronRight16 color="icon-main-default" />
        </label>
      )}
    </ModalWindow>
  );
};
